/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpigreq43Inputs */

const en_crosspostinghelpigreq43 = /** @type {(inputs: Crosspostinghelpigreq43Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need admin rights on the Instagram account and must grant all permissions in the Meta dialog. If you see "Error connecting Instagram", simply try again.`)
};

const de_crosspostinghelpigreq43 = /** @type {(inputs: Crosspostinghelpigreq43Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du brauchst Admin-Rechte auf dem Instagram-Konto und musst im Meta-Dialog alle Berechtigungen erteilen. Bei „Error connecting Instagram“ einfach erneut versuchen.`)
};

/**
* | output |
* | --- |
* | "You need admin rights on the Instagram account and must grant all permissions in the Meta dialog. If you see \"Error connecting Instagram\", simply try again." |
*
* @param {Crosspostinghelpigreq43Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpigreq43 = /** @type {((inputs?: Crosspostinghelpigreq43Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpigreq43Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpigreq43(inputs)
	return de_crosspostinghelpigreq43(inputs)
});
export { crosspostinghelpigreq43 as "crosspostingHelpIgReq4" }